import React, { useEffect, useState } from "react";
import { Container, Table, Button } from "react-bootstrap";

function CompressedVideoList() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch("https://extapi.jacuji.com/api/videos/compressed")
      .then(res => res.json())
      .then(data => setVideos(data.data || []));
  }, []);

  const download = (id) => {
    window.open(
      `https://extapi.jacuji.com/api/videos/download/${id}`,
      "_blank"
    );
  };

  return (
    <Container className="mt-5">
      <h4>Videos</h4>

      <Table bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Filename</th>
            <th>Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {videos.map((v, i) => (
            <tr key={v.id}>
              <td>{i + 1}</td>
              <td>{v.filename}</td>
              <td>{(v.is_compressed==='true') ? "Compressed" : "Original"}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => download(v.id)}
                >
                  Download
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default CompressedVideoList;
